import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import config from "../../../config/config";

function WeeklyReport() {
  const reportUrl = useMemo(() => {
    const base = config.API_BASE_URL || "";
    const origin = base || window.location.origin;
    // Load base HTML; embedded page manages its own query params
    return `${origin}/api/employee/report-weekly-html`;
  }, []);

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>
          Weekly Report
          <i
            className="bi bi-info-circle ms-2"
            style={{ cursor: "pointer", fontSize: "1rem" }}
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="View weekly attendance summary rendered by the server."
          ></i>
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item active">Weekly Report</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Weekly Report</h5>

                <div className="border rounded" style={{ minHeight: 600 }}>
                  <iframe
                    title="Weekly Report"
                    src={reportUrl}
                    style={{ width: "100%", height: "80vh", border: 0 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default WeeklyReport;


